import { createContext, PropsWithChildren, useContext } from 'react';

export type BookstoreModuleType = 'biblioteca' | 'banca' | 'audiobook';

interface BookstoreModuleContextValue {
  moduleType: BookstoreModuleType;
}

const BookstoreModuleContext = createContext<BookstoreModuleContextValue | null>(null);

export function BookstoreModuleProvider({
  type,
  children,
}: PropsWithChildren<{ type: BookstoreModuleType }>) {
  return (
    <BookstoreModuleContext.Provider value={{ moduleType: type }}>
      {children}
    </BookstoreModuleContext.Provider>
  );
}

export function useBookstoreModule(): BookstoreModuleContextValue | null {
  return useContext(BookstoreModuleContext);
}
